import { cn } from '@/lib/shared/ui';
import React from 'react';

export const P = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>,
) => <p {...props} className={cn('m-0 leading-normal', props.className)} />;

export type HeadingProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>;

const sharedHeadingClasses = 'font-bold';

export const H1 = (props: HeadingProps) => (
  <h1 {...props} className={cn('text-4xl', sharedHeadingClasses, props.className)} />
);

export const H2 = (props: HeadingProps) => (
  <h2 {...props} className={cn('text-3xl', sharedHeadingClasses, props.className)} />
);

export const H3 = (props: HeadingProps) => (
  <h3 {...props} className={cn('text-2xl', sharedHeadingClasses, props.className)} />
);

export const H4 = (props: HeadingProps) => (
  <h4 {...props} className={cn('text-xl', sharedHeadingClasses, props.className)} />
);

export const H5 = (props: HeadingProps) => (
  <h5 {...props} className={cn('text-lg', sharedHeadingClasses, props.className)} />
);

export const UL = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement>,
) => (
  <ul {...props} className={cn('list-disc list-outside leading-normal ps-6', props.className)} />
);

export const OL = (
  props: React.DetailedHTMLProps<React.OlHTMLAttributes<HTMLOListElement>, HTMLOListElement>,
) => (
  <ol {...props} className={cn('list-decimal list-outside leading-normal ps-6', props.className)} />
);

export const LI = (
  props: React.DetailedHTMLProps<React.LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>,
) => <li {...props} className={cn('leading-normal list-outside pl-2', props.className)} />;

export const Code = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>,
) => (
  <code
    {...props}
    className={cn(
      'bg-accent-three/20 tracking-wide border border-accent-three/30 rounded px-1 py-0.5 font-mono text-sm',
      props.className,
    )}
  />
);
